import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Table, Spinner, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";

const RecentFile = () => {
  const [files, setFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [endpointMissing, setEndpointMissing] = useState(false);

  // Dosyaları Sunucudan Çek
  const fetchFiles = async () => {
    setIsLoading(true);
    setEndpointMissing(false);
    try {
      // 'list_files.php' API tarafında deploy edilmemiş — 404/CORS gelirse sessiz devam.
      const response = await fetch("https://harmanappapi.stechomeyazilim.info/Uploads/list_files.php");
      if (!response.ok) {
        setEndpointMissing(true);
        setFiles([]);
        return;
      }
      const result = await response.json();
      if (result.status) {
        setFiles(result.data);
      }
    } catch (error) {
      // Endpoint yok / CORS — kullanıcıyı toast bombardımanına tutma, sadece bilgi göster
      setEndpointMissing(true);
      setFiles([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFiles();
  }, []);

  // Dosya İkonu Belirleme Mantığı
  const getFileIcon = (ext) => {
    switch (ext.toLowerCase()) {
      case 'pdf': return 'mdi mdi-file-pdf text-danger';
      case 'png': case 'jpg': case 'jpeg': return 'mdi mdi-image text-success';
      case 'doc': case 'docx': return 'mdi mdi-file-word text-info';
      default: return 'mdi mdi-file-document text-muted';
    }
  };

  return (
    <React.Fragment>
      <div className="mt-4">
        <div className="d-flex flex-wrap align-items-center">
          <h5 className="font-size-16 me-3 mb-0">Sunucudaki Dosyalar (Uploads)</h5>
          <div className="ms-auto">
            <Link to="#" className="fw-medium text-primary" onClick={(e) => { e.preventDefault(); fetchFiles(); }}>
              <i className="mdi mdi-refresh me-1"></i>Yenile
            </Link>
          </div>
        </div>
        <hr className="mt-3" />

        {isLoading ? (
          <div className="text-center py-4"><Spinner color="primary" /></div>
        ) : endpointMissing ? (
          <div className="text-center text-muted py-3">
            <i className="mdi mdi-information-outline me-1" />
            Dosya listeleme servisi (Uploads/list_files.php) sunucuda yapılandırılmamış.
          </div>
        ) : files.length === 0 ? (
          <div className="text-center text-muted py-3">Henüz yüklenmiş bir dosya yok.</div>
        ) : (
          <div className="table-responsive">
            <Table className="table align-middle table-nowrap table-hover mb-0">
              <thead className="table-light">
                <tr>
                  <th scope="col">Dosya Adı</th>
                  <th scope="col">Yüklenme Tarihi</th>
                  <th scope="col">Boyut</th>
                  <th scope="col">Aksiyon</th>
                </tr>
              </thead>
              <tbody>
                {files.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <a href={item.url} target="_blank" rel="noreferrer" className="text-dark fw-medium">
                        <i className={`${getFileIcon(item.ext)} font-size-18 me-2 align-middle`}></i> 
                        {item.name}
                      </a>
                    </td>
                    <td>{new Date(item.date).toLocaleDateString('tr-TR')} {new Date(item.date).toLocaleTimeString('tr-TR', {hour: '2-digit', minute:'2-digit'})}</td>
                    <td>{item.size}</td>
                    <td>
                      <UncontrolledDropdown>
                        <DropdownToggle tag="a" className="font-size-16 text-muted" role="button">
                          <i className="mdi mdi-dots-horizontal"></i>
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-end">
                          <DropdownItem href={item.url} target="_blank">Aç / Görüntüle</DropdownItem>
                          <DropdownItem href={item.url} download>İndir</DropdownItem>
                          <div className="dropdown-divider"></div>
                          <DropdownItem className="text-danger" href="#">Sil</DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default RecentFile;